module.exports = __webpack_public_path__ + "img/application_black_icon.ae044bf9.svg";